import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { 
  Box, 
  Button, 
  Container, 
  Typography, 
  TextField, 
  Paper, 
  Alert, 
  CircularProgress 
} from '@mui/material';

const DebugApi = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(user?.uid || '');
  
  const testSubscriptionStatus = async () => {
    if (!user) {
      setError('No user logged in');
      return;
    }
    
    setLoading(true);
    setResults(null);
    setError(null);
    
    try {
      // Get a fresh token
      const token = await user.getIdToken(true);
      
      // First test the debug endpoint
      const debugResponse = await fetch(`/api/debug/subscription-status/${userId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      const debugData = await debugResponse.json();
      
      // Then test the check-subscription endpoint
      const subResponse = await fetch('/api/check-subscription', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      let subData = {};
      let subStatusCode = subResponse.status;
      
      try {
        if (subResponse.status !== 204) { // Only try to parse JSON if there's content
          subData = await subResponse.json();
        }
      } catch (e) {
        subData = { error: 'Could not parse response as JSON' };
      }
      
      setResults({
        userId: userId,
        debug: debugData,
        subscription: {
          statusCode: subStatusCode,
          data: subData
        },
        token: token.substring(0, 20) + '...'
      });
    } catch (error) {
      console.error('Test failed:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        API Debug Tool
      </Typography>
      
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Test Subscription Status
        </Typography>
        
        <Box sx={{ mb: 2 }}>
          <TextField
            label="User ID"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
          />
        </Box>
        
        <Button
          variant="contained"
          color="primary"
          onClick={testSubscriptionStatus}
          disabled={loading || !userId}
        >
          {loading ? <CircularProgress size={24} /> : 'Test API'}
        </Button>
      </Paper>
      
      {error && (
        <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
          {error}
        </Alert>
      )}
      
      {results && (
        <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
          <Typography variant="h6" gutterBottom>Results</Typography>
          <pre style={{ 
            backgroundColor: '#f5f5f5', 
            padding: '1rem', 
            borderRadius: '4px',
            overflow: 'auto',
            maxHeight: '500px'
          }}>
            {JSON.stringify(results, null, 2)}
          </pre>
        </Paper>
      )}
    </Container>
  );
};

export default DebugApi; 